module.exports = __webpack_public_path__ + "acf42c8296a30fb5bd0c374c9cb800b3.png";